module.exports = __webpack_public_path__ + "img/_givens_.b91a44e2.svg";